import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { CardContent } from '@mui/material';
import { makeStyles } from '@material-ui/styles';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import React from 'react';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import SmsManagement from '../SmsManagement/index';
import SmsCreate from '../SmsManagement/SmsCreate';
import EditNoteIcon from '@mui/icons-material/EditNote';
import SmsTextGuide from '../SmsManagement/SmsTextGuide';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SmsReporting from '../SmsManagement/SmsReporting';


const useStyles = makeStyles((theme) => ({
  root: {
    fontFamily: "Segoe UI",
    width: '100%',
    height: '100%'
  }

}));


function Overview() {

  const classes = useStyles();
  const [value, setValue] = React.useState('1')

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Card>
        <CardContent>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList variant='fullWidth' centered onChange={handleChange}
                  sx={{
                    textColor: '#424242',
                    "& .css-xe9pe1-MuiButtonBase-root-MuiTab-root.Mui-selected": {
                      color: "#FF9800"
                    }, "& .css-10hkket.Mui-selected": {
                      color: "#FF9800"
                    },
                  }}
                >
                  <Tab sx={{ width: '100%' }} icon={<CompareArrowsIcon />} label="Sms Yönet" value="1" />
                  <Tab sx={{ width: '100%' }} icon={<EditNoteIcon />} label="Sms Oluştur" value="2" />
                  <Tab sx={{ width: '100%' }} icon={<AssessmentIcon />} label="Sms Raporlama" value="3" />
                </TabList>
                <TabPanel value="1">
                  <SmsManagement />
                </TabPanel>
                <TabPanel value="2">
                  <SmsTextGuide />
                  <SmsCreate />
                </TabPanel>
                <TabPanel value="3">
                  <SmsReporting />
                </TabPanel>
              </Box>
            </TabContext>
          </Box>
        </CardContent>
      </Card>
    </>
  );

}

export default Overview;